import { gql } from 'glimmer-apollo';

export const NEWS_SLIDER_QUERY = gql`
  query {
    articles: gameArticles(limit: 4) {
      __typename
      title
      slug
      shortDescription
      publishedDate
      coverImage {
        url
      }
      author {
        name
        slug
        avatar {
          url
        }
      }
    }
  }
`;
